import { sortMapListings } from '../../models/map-result-sort';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RealEstateState } from '../states/real-estate.state';

export const selectRealEstateState = createFeatureSelector<RealEstateState>('realEstate');

export const selectRealEstateSearchResults = createSelector(
  selectRealEstateState,
  (state) => state.propertyResults
);

export const selectRealEstateMapSearchResults = createSelector(
  selectRealEstateState,
  (state) => state.propertyMapResults
);

export const selectRealEstateReportResults = createSelector(
  selectRealEstateState,
  (state) => state.propertyReports
);

export const selectTopRealEstateSearchResults = createSelector(
  selectRealEstateState,
  (state) => state.topPropertyResults
);

export const selectRealEstate = createSelector(selectRealEstateState, (state) => state.realEstate);

export const selectRealEstateSearchLoading = createSelector(
  selectRealEstateState,
  (state) => state.isRealEstateMapView ? state.mapLoading : state.listLoading
);

export const selectRealEstateIsSaving = createSelector(
  selectRealEstateState,
  (state) => state.isSaving
);
export const selectRealEstateSearchError = createSelector(selectRealEstateState, (state) => state.isRealEstateMapView ? state.mapError : state.listError);

export const selectTopRealEstateSearchLoading = createSelector(
  selectRealEstateState,
  (state) => state.topLoading
);

export const selectRealEstateSearchForm = createSelector(
  selectRealEstateState,
  (state: RealEstateState) => state.query
);

export const selectRealEstateMapSearchForm = createSelector(
  selectRealEstateState,
  (state: RealEstateState) => state.mapQuery
);

export const selectRealEstateReportForm = createSelector(
  selectRealEstateState,
  (state: RealEstateState) => state.reportQuery
);

export const selectRealEstateSort = createSelector(selectRealEstateState, (state) => state.isRealEstateMapView ? state.mapSort : state.sort);

export const selectRealEstatePagination = createSelector(
  selectRealEstateState,
  (state) => state.pagination
);

export const selectIsRealEstateMapView = createSelector(
  selectRealEstateState,
  (state) => state.isRealEstateMapView
);
export const selectRealEstatePolygon = createSelector(
  selectRealEstateState,
  (state) => state.activePolygon
);

export const selectRealEstatePolygonRevision = createSelector(
  selectRealEstateState,
  (state) => state.polygonRevision
);

// A missing response is neutral, not a successful empty search.
export const selectRealEstateSearchEmpty = createSelector(
  selectRealEstateState,
  state => !state.listLoading && !state.listError && state.propertyResults?.total === 0
);

export const selectRealEstateError = createSelector(selectRealEstateState, state => state.error);

export const selectRealEstateMapLoading = createSelector(selectRealEstateState, state => state.mapLoading);
export const selectRealEstateMapError = createSelector(selectRealEstateState, state => state.mapError);

export const selectRealEstateMapSort = createSelector(selectRealEstateState, state => state.mapSort);
export const selectRealEstateMapListItems = createSelector(selectRealEstateMapSearchResults, selectRealEstateMapSort,
  (result, sort) => sortMapListings(result?.items ?? [], sort));
